import React from 'react';
import CloroxProductGroupDetail from 'components/Tvendo/Sale/QuotaBPartner/Clorox/ProductGroupsClorox/Detail/Detail';

export default function () {
  return <CloroxProductGroupDetail />;
}
